import Select from "react-select";
import { FaInfoCircle } from "react-icons/fa";
import { Tooltip } from "react-tooltip";
import "./dropDown.css";
import {
  getRecentMunicipalities,
  addRecentMunicipality,
} from "../utils/recentMunicipalities";
import { useEffect, useState } from "react";

const DropDownSearch = ({
  headerText,
  ddData,
  setText,
  text,
  jsonText,
  remValKommun,
  setRemValKommun,
  errText = "",
  validateIsErr,
  tooltipText = "",
}) => {
  const [options, setOptions] = useState([]);

  useEffect(() => {
    if (jsonText === "kobject") {
      // Only for municipality dropdown
      const recentMunicipalities = getRecentMunicipalities();
      const mainOptions = ddData.map(({ mch_object, kommun }) => ({
        value: mch_object,
        label: kommun,
      }));

      if (recentMunicipalities.length > 0) {
        setOptions([
          {
            label: "Senast använda",
            options: recentMunicipalities,
          },
          {
            label: "Alla kommuner",
            options: mainOptions,
          },
        ]);
      } else {
        setOptions(mainOptions);
      }
    }
  }, [ddData, jsonText]);

function handleChange(evt) {
  if (evt.value !== "NA") {
    setRemValKommun(evt.value);

    setText((prev) => ({
      ...prev,
      kobject: evt.value,
      kommun: evt.label,
      shortDesc: prev.referensnummer
        ? `${evt.label} - ${prev.referensnummer}`
        : `${evt.label} - `,
    }));

    if (jsonText === "kobject") {
      addRecentMunicipality({ value: evt.value, label: evt.label });
    }
  } else {
    setRemValKommun("NA");

    setText((prev) => ({
      ...prev,
      kobject: "",
      kommun: "",
      shortDesc: prev.referensnummer || "",
    }));
  }
}

  const styles = {
    control: (base) => ({
      ...base,
      backgroundColor: "#D8D9DB",
      borderColor: "red",
      border: validateIsErr[jsonText] === true ? "" : "none",
      borderRadius: "10px",
    }),
    singleValue: (base) => ({
      ...base,
      padding: "5px 10px",
      borderRadius: 5,
      display: "flex",
    }),
    menuList: (base) => ({
      ...base,
      maxHeight: "230px",
    }),
    group: (base) => ({
      ...base,
      paddingTop: 0,
      "&:not(:first-of-type)": {
        borderTop: "1px solid #ccc",
        marginTop: 8,
        paddingTop: 8,
      },
    }),
  };

  return (
    <>
      <h6 className="txtH6dd">
        {headerText}{" "}
        <FaInfoCircle
          id={`info-circel-${jsonText}`}
          className="infoCircelTop"
          data-tooltip-html={tooltipText}
          display={tooltipText.length === 0 ? "none" : ""}
        />
        <Tooltip
          anchorId={`info-circel-${jsonText}`}
          className="infoCircelTop2"
          multiline={true}
          data-html={true}
          html
        />
      </h6>
      <Select
        onChange={handleChange}
        className="reactSelect reactSelectObject"
        name={jsonText}
        isSearchable={true}
        value={{
          value: text.kobject,
          label: text.kommun === "" ? "Välj kommun..." : text.kommun,
        }}
        options={
          jsonText === "kobject"
            ? options
            : ddData.map(({ mch_object, kommun }) => ({
                value: mch_object,
                label: kommun,
              }))
        }
        styles={styles}
      />
      <br />
      <small className="errSmalldd">
        {validateIsErr[jsonText] === true ? errText : ""}
      </small>
    </>
  );
};

export default DropDownSearch;
